export default "__VITE_ASSET__Dyx0Nj1s__"